import React from "react";
import { Formik, ErrorMessage } from "formik";
import ImageUploader from "../components/ImageUploader";
import FormFooterButtons from "../components/FormFooterButtons";

import { Card } from "react-bootstrap";
import { GetUUID } from "../data/helpers/RandomNumGenerator";
import {
	add,
	pondAddress,
	moderatorInfo,
	name,
	phone,
	pondArea,
	annualProduction,
	annualIncome,
	ownerName,
	wardQuestion,
	annualPalikaFee,
	fishFarmOwnership,
	areaList,
	area,
	unit,
	cancel,
	ward,
	selectedLanguage,
	photo,
} from "../data/institute";
const initData = {
	pondArea: "",
	pondAddress: "",
	ward: "",
	annualProduction: "",
	annualPalikaFee: "",
	moderatorName: "",
	moderatorPhonenumber: "",
	ownership: "",
	annualIncome: "",
	uniqueIdentifier: GetUUID(),
};
const FishFarm = (props) => (
	<div>
		<Formik
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				// if (!values.name) {
				//     errors.name = 'Required';
				// }
				// if (!values.pondAddress) {
				//     errors.pondAddress = 'Required';
				// }
				// if (!values.address) {
				//     errors.address = 'Required';
				// }
				// if (!values.area) {
				//     errors.area = 'Required';
				// }
				// if (!values.farmType) {
				//     errors.farmType = 'Required';
				// }
				// if (!values.unit) {
				//     errors.unit = 'Required';
				// }
				// if (!values.rate) {
				//     errors.rate = 'Required';
				// }
				// if (!values.animal) {
				//     errors.animal = 'Required';
				// }
				// if (!values.presidentContact) {
				//     errors.presidentContact = 'Required';
				// }
				// if (!values.presidentName) {
				//     errors.presidentName = 'Required';
				// }
				// if (!values.total) {
				//     errors.total = 'Required';
				// }
				// if (!values.fetotal) {
				//     errors.fetotal = 'Required';
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				props.submit(values);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{pondAddress[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={pondAddress[selectedLanguage]}
											name="pondAddress"
											onChange={handleChange}
											value={values.pondAddress}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="pondAddress"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											defaultValue="selectOne"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward ? values.ward : "selectOne"}
										>
											<option value="selectOne" disabled>
												कुनै एक छान्नुहोस्
											</option>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{area[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={area[selectedLanguage]}
											name="pondArea"
											onChange={handleChange}
											value={values.pondArea}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="pondArea"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{annualProduction[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={annualProduction[selectedLanguage]}
											name="annualProduction"
											onChange={handleChange}
											value={values.annualProduction}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="annualProduction"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{ownerName[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ownership"
											name="ownership"
											onChange={handleChange}
											value={values.ownership}
										>
											{fishFarmOwnership.map((type) => (
												<option value={type.value}>
													{type[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ownership"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{annualPalikaFee[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={annualPalikaFee[selectedLanguage]}
											name="annualPalikaFee"
											onChange={handleChange}
											value={values.annualPalikaFee}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="annualPalikaFee"
											component="div"
										/>
									</div>
								</div>
								<hr />
								<h3>{moderatorInfo[selectedLanguage]}</h3>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{name[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={name[selectedLanguage]}
											name="moderatorName"
											onChange={handleChange}
											value={values.moderatorName}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="moderatorName"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{phone[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={phone[selectedLanguage]}
											name="moderatorPhonenumber"
											onChange={handleChange}
											value={values.moderatorPhonenumber}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="moderatorPhonenumber"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>
								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default FishFarm;
